import { useContext } from "react";

import { EncodeSpecificationContext } from "../../context/EncodeSpecificationContext";

export const useEncodeSpecificationValidator = () => {
    const { encodeSpecifications } = useContext(EncodeSpecificationContext);

    const isNameUnique = (name: string, encodeSpecId?: string): boolean => {
        const encodeSpec = encodeSpecifications.find((spec) => spec.name.toLowerCase() === name.toLowerCase());

        if (encodeSpec && encodeSpec.id !== encodeSpecId) {
            return false;
        }

        return true;
    };

    return {
        isNameUnique
    };
};
